import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { AddStationComponent } from './components/Station/add-station/add-station.component';
import { AlertsAnsNotificationComponent } from './components/alerts-ans-notification/alerts-ans-notification.component';
import { StationsListComponent } from './components/Station/stations-list/stations-list.component';
import { VendorViewComponent } from './components/Vedors/vendor-view/vendor-view.component';
import { CreateVendorComponent } from './components/Vedors/create-vendor/create-vendor.component';
import { VendorDetailsComponent } from './components/Vedors/vendor-details/vendor-details.component';
import { StationDetailsComponent } from './components/Station/station-details/station-details.component';
import { MobileUsersComponent } from './components/Mobile/mobile-users/mobile-users.component';
import { ServiceRequestComponent } from './components/service-request/service-request.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { InformationComponent } from './components/information/information.component';
import { EditServiceRequestComponent } from './components/edit-service-request/edit-service-request.component';
import { EditVendorServiceRequestComponent } from './components/edit-vendor-service-request/edit-vendor-service-request.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsComponent } from './components/terms/terms.component';
import { ReferAfriendComponent } from './components/refer-afriend/refer-afriend.component';
import { HomeComponent } from './components/home/home.component';
import { AppResolver } from './_services/resolver/AppResolver.service';
import { RfidListComponent } from './components/Rfid/rfid-list/rfid-list.component';
import { RfidCreateComponent } from './components/Rfid/rfid-create/rfid-create.component';
import { RfidEditComponent } from './components/Rfid/rfid-edit/rfid-edit.component';
import { RfidDetailsComponent } from './components/Rfid/rfid-details/rfid-details.component';
import { RfidAssignComponent } from './components/Rfid/rfid-assign/rfid-assign.component';
import { RfidUserComponent } from './components/Rfid/rfid-user/rfid-user.component';
import { GrafanaComponent } from './components/grafana/grafana.component';
import { ChargingProfilesComponent } from './components/smart-charging/charging-profiles/charging-profiles.component';
import { CreateChargingProfileComponent } from './components/smart-charging/create-charging-profile/create-charging-profile.component';
import { FaqComponent } from './components/faq/faq.component';
import { CreateUserComponent } from './components/create-user/create-user.component';
import { ReferalPageComponent } from './components/referal-page/referal-page.component';
import { WalletsComponent } from './components/wallets/wallets.component';
import { UserTransactionsComponent } from './components/user-transactions/user-transactions.component';
import { ChargingTransactionsComponent } from './components/charging-transactions/charging-transactions.component';
import { RouteConstants } from './util/route.constants';
import { DeleteMobileComponent } from './shared/delete-mobile/delete-mobile.component';

const routes: Routes = [
  { path: "login", component: HomeComponent },
  { path: "", component: HomeComponent },
  { path: "dashboard", component: DashboardComponent, resolve: { appResolver: AppResolver } },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  { path: "terms&conditions", component: TermsComponent },
  { path: "referral/telioEv", component: ReferalPageComponent },
  { path: "referral/chargengo", component: ReferalPageComponent },
  { path: "referral/zappCharge", component: ReferalPageComponent },
  { path: "referral/electricOne", component: ReferalPageComponent },
  { path: "referral/evChargify", component: ReferalPageComponent },
  { path: "referral/evCosmos", component: ReferalPageComponent },
  { path: "referral/anupEVConnect", component: ReferalPageComponent },
  { path: "referral/asarkElectric", component: ReferalPageComponent },
  { path: "referral/shuzlanEnergy", component: ReferalPageComponent },
  { path: "referral/erisha", component: ReferalPageComponent },
  { path: "referral/levicon", component: ReferalPageComponent },
  { path: "referral/celectric", component: ReferalPageComponent },
  { path: "referral/charjkaro", component: ReferalPageComponent },
  { path: "referral/beyondMiles", component: ReferalPageComponent },
  { path: "deleteUser/:tenantId", component: DeleteMobileComponent },
  {
    // canActivate: [AuthGuard]
    path: "dashboard",
    component: DashboardComponent, resolve: { appResolver: AppResolver }, children: [
      { path: "home", component: MapViewComponent, data: RouteConstants.HOME },
      { path: 'revenue', component: GrafanaComponent, data: RouteConstants.ANALYTICS_REVENUE },
      { path: 'footfall', component: GrafanaComponent, data: RouteConstants.ANALYTICS_FOOTFALL },
      { path: 'chargebox', component: GrafanaComponent, data: RouteConstants.ANALYTICS_CHARGEBOX },
      { path: 'deepdive', component: GrafanaComponent, data: RouteConstants.ANALYTICS_DEEPDIVE },
      { path: "operators", component: VendorViewComponent, data: RouteConstants.CHARGE_POINT_OPERATORS },
      { path: "operators/create", component: CreateVendorComponent },
      { path: "operators/details", component: VendorDetailsComponent, data: RouteConstants.CHARGE_POINT_OPERATORS },
      { path: "operators/edit", component: CreateVendorComponent, data: RouteConstants.CHARGE_POINT_OPERATORS },
      { path: "stations", component: StationsListComponent, data: RouteConstants.STATIONS },
      { path: "stations/details", component: StationDetailsComponent, data: RouteConstants.STATION_DETAILS },
      { path: "add-station", component: AddStationComponent, data: RouteConstants.ADD_STATION },
      { path: 'charging-profiles', component: ChargingProfilesComponent, data: RouteConstants.CHARGING_PROFILE },
      { path: 'charging-profiles/create', component: CreateChargingProfileComponent },
      { path: 'charging-transactions', component: ChargingTransactionsComponent, data: RouteConstants.CHARGING_TRANSACTION },
      { path: 'tariff', loadChildren: () => import('./components/tariff/tariff.module').then(m => m.TariffModule) },
      { path: 'mobile-users', component: MobileUsersComponent, data: RouteConstants.MOBILE_USERS },
      { path: 'mobile-users/create', component: CreateUserComponent, data: RouteConstants.MOBILE_USERS_CREATE },
      { path: 'mobile-users/transactions', component: TransactionsComponent },
      { path: 'wallets', component: WalletsComponent, data: RouteConstants.WALLETS },
      { path: 'wallets/transactions', component: TransactionsComponent },
      { path: 'transactions', component: UserTransactionsComponent, data: RouteConstants.TRANSACTIONS },
      { path: "rfid", component: RfidListComponent, data: RouteConstants.RFID },
      { path: "rfid/create", component: RfidCreateComponent },
      { path: "rfid/assign", component: RfidAssignComponent },
      { path: "rfid/edit-assign", component: RfidEditComponent },
      { path: "rfid/details", component: RfidDetailsComponent },
      { path: "rfid/user", component: RfidUserComponent },
      { path: 'refer-friend', component: ReferAfriendComponent, data: RouteConstants.REFER_FRIEND },
      { path: 'report', loadChildren: () => import('./components/report/report.module').then(m => m.ReportModule) },
      { path: 'user-management', loadChildren: () => import('./components/user-management/user-mangement.module').then(m => m.UserManagementModule) },
      { path: 'tenants', loadChildren: () => import('./components/landing/landing.module').then(m => m.LandingModule) },
      { path: 'service-request', component: TicketsComponent, data: RouteConstants.SERVICE_REQUEST },
      { path: 'service-request/new-request', component: ServiceRequestComponent },
      { path: 'service-request/edit', component: EditServiceRequestComponent },
      { path: 'service-request/edit-vendor', component: EditVendorServiceRequestComponent },
      { path: 'info', component: InformationComponent, data: RouteConstants.INFO, resolve: { appResolver: AppResolver } },
      { path: "alerts", component: AlertsAnsNotificationComponent, data: RouteConstants.ALERTS },
      { path: 'faq', component: FaqComponent, data: RouteConstants.FAQ },
      { path: 'tariff-management', loadChildren: () => import('./components/tariff-management/tariff-management.module').then(m => m.TariffManagementModule) },
      { path: 'charge-point-operators', loadChildren: () => import('./components/charge-point-operators/charge-point-operators.module').then(m => m.ChargePointOperatorsModule) }
    ],
  },
  { path: "**", component: HomeComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  // imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [AppResolver]
})
export class AppRoutingModule { }
